/**
 * File for querying endpoints data
 * 
 * Author: Sahil David
 */

import store from '@/bootstrap/services/store';

import { ILyraObject, ILyraEndpointData } from '../@types';
import { addEndpointFallback } from './lyra.data';

/**
 * Function to query lyra endpoints
 */
export async function $lyraEndpoints (params: ILyraEndpointData): Promise<any> {
	let endpointData: any = {};

	const { endpointId, tierId } = params;
	if (!(endpointId || tierId)) { return endpointData; }

	try {
		const $lyra: ILyraObject = store.getters.get_$lyra;
		const response = await $lyra.endpoints({
			tierId,
			endpointId,
		});

		if (response.success && response.data) {
            const [datum] = response.data;
            endpointData = addEndpointFallback(datum) || {};
        }
	} catch (err) {
		console.warn(err);
	}

	return endpointData;
}